// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1liHg","placeholdersHeader":"styles_placeholdersHeader__2NcB5","editorStyle":"styles_editorStyle__3HdDb","placeholdersBox":"styles_placeholdersBox__3JlMJ"};